import React from 'react';
import { Link } from 'react-router-dom';
import BackLink from './BackLink';
import './ui.css';

/**
 * The top of every page. With a back link: the link on the left and the one
 * main action on the right, then the title, then an optional grey details
 * line. A top-level page has no back link, so the title sits in the bar.
 *
 * back: { to, label }  e.g. { to: '/admin-hub', label: 'Admin' }
 * title: the page title (rendered as the page's h1, sentence case)
 * details: optional grey line under the title
 * action: { label, short, onClick | to, disabled }. `short` is what phones
 *   show ("Add" for "Add a session type"). Or a ready-made button element,
 *   given the className 'bk-btn bk-btn--primary bk-btn--sm ui-header__action'.
 */
export default function PageHeader({ back, title, details, action }) {
  const titleEl = <h1 className="ui-header__title">{title}</h1>;
  return (
    <header className="ui-header">
      <div className="ui-header__bar">
        {back ? <BackLink to={back.to} label={back.label} /> : titleEl}
        {action && (React.isValidElement(action) ? action : <HeaderAction {...action} />)}
      </div>
      {back && titleEl}
      {details && <p className="ui-header__details">{details}</p>}
    </header>
  );
}

function HeaderAction({ label, short, onClick, to, disabled }) {
  const text = short && short !== label ? (
    <>
      <span className="ui-header__short">{short}</span>
      <span className="ui-header__long">{label}</span>
    </>
  ) : label;
  const className = 'bk-btn bk-btn--primary bk-btn--sm ui-header__action';
  if (to) return <Link to={to} className={className} aria-label={short && short !== label ? label : undefined}>{text}</Link>;
  return (
    <button type="button" className={className} onClick={onClick} disabled={disabled} aria-label={short && short !== label ? label : undefined}>
      {text}
    </button>
  );
}
